import { ITranslationEntry } from '../lang';

export const GU: ITranslationEntry = {
  translations: {
    notifications: 'સૂચના',
    markAllAsRead: 'બધાને વાંચેલા તરીકે ચિહ્નિત કરો',
    poweredBy: 'દ્વારા સંચાલિત',
    settings: 'સેટિંગ્સ',
  },
  lang: 'gu',
};
